import api from '@/api/axios';
import type { BffApiResponse } from '@/types';

export interface ProfileResponse {
  firstName: string;
  lastName: string;
  userRole: string;
  phone: string;
  email: string;
}

export interface UpdateProfileRequest {
  firstName: string;
  lastName: string;
  userRole: 'operator' | 'comissionist' | 'adviser' | 'none';
  phone: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
  confirmPassword: string;
}

class AuthProfileService {
  private readonly basePath = '/admin/auth';

  async getProfile(): Promise<BffApiResponse<ProfileResponse>> {
    const response = await api.get<BffApiResponse<ProfileResponse>>(
      `${this.basePath}/profile`
    );
    return response.data;
  }

  async updateProfile(
    data: UpdateProfileRequest
  ): Promise<BffApiResponse<ProfileResponse>> {
    const response = await api.put<BffApiResponse<ProfileResponse>>(
      `${this.basePath}/profile`,
      data
    );
    return response.data;
  }

  async changePassword(
    data: ChangePasswordRequest
  ): Promise<BffApiResponse<null>> {
    const response = await api.post<BffApiResponse<null>>(
      `${this.basePath}/change-password`,
      data
    );
    return response.data;
  }
}

export const authProfileService = new AuthProfileService();
export default authProfileService;